<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.TransferAsset">Transfer Asset</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Transfer Asset Id" [matTooltipDisabled]="disabledTooltip(this.transferAssetId)">
          <mat-label i18n="@@type.TransferAsset.transferAssetId">Transfer Asset Id</mat-label>
          <input matInput formControlName="transferAssetId" id="transferAssetIdFilterInput"
            (ngModelChange)="transferAssetIdChanging($event)" [(ngModel)]="transferAssetIdFilter"
            (ngModelChange)="transferAssetIdChanged($event)" #transferAssetIdFilterInput type="number"
            placeholder="Transfer Asset Id">
        </mat-form-field>

        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.TransferAsset.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnitFilterInput"
            (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="businessUnitFilter"
            (ngModelChange)="businessUnitChanged($event)" #businessUnitFilterInput placeholder="Business Unit"
            [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Cost Centre from the list"
          [matTooltipDisabled]="disabledTooltip(this.costCentre)">
          <mat-label i18n="@@type.TransferAsset.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentreFilterInput"
            (ngModelChange)="costCentreChanging($event)" [(ngModel)]="costCentreFilter"
            (ngModelChange)="costCentreChanged($event)" #costCentreFilterInput placeholder="Cost Centre"
            [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

      <div class="search-section">

        <mat-form-field matTooltip="Approval Rejection Comment"
          [matTooltipDisabled]="disabledTooltip(this.approvalRejectionComment)">
          <mat-label i18n="@@type.TransferAsset.approvalRejectionComment">Approval Rejection Comment</mat-label>
          <input matInput formControlName="approvalRejectionComment" id="approvalRejectionCommentFilterInput"
            (ngModelChange)="approvalRejectionCommentChanging($event)" [(ngModel)]="approvalRejectionCommentFilter"
            (ngModelChange)="approvalRejectionCommentChanged($event)" #approvalRejectionCommentFilterInput
            maxlength="1000" placeholder="Approval Rejection Comment">
        </mat-form-field>

        <mat-form-field matTooltip="Approved" [matTooltipDisabled]="disabledTooltip(this.approved)">
          <mat-label i18n="@@type.TransferAsset.approved">Approved</mat-label>
          <input matInput formControlName="approved" id="approvedFilterInput" (ngModelChange)="approvedChanging($event)"
            [(ngModel)]="approvedFilter" (ngModelChange)="approvedChanged($event)" #approvedFilterInput maxlength="255"
            placeholder="Approved">
        </mat-form-field>

        <mat-form-field matTooltip="Approved Rejected By"
          [matTooltipDisabled]="disabledTooltip(this.approvedRejectedBy)">
          <mat-label i18n="@@type.TransferAsset.approvedRejectedBy">Approved Rejected By</mat-label>
          <input matInput formControlName="approvedRejectedBy" id="approvedRejectedByFilterInput"
            (ngModelChange)="approvedRejectedByChanging($event)" [(ngModel)]="approvedRejectedByFilter"
            (ngModelChange)="approvedRejectedByChanged($event)" #approvedRejectedByFilterInput maxlength="40"
            placeholder="Approved Rejected By">
        </mat-form-field>

        <mat-form-field matTooltip="Approved Rejected Date"
          [matTooltipDisabled]="disabledTooltip(this.approvedRejectedDate)">
          <mat-label i18n="@@type.TransferAsset.approvedRejectedDate">Approved Rejected Date</mat-label>
          <input matInput formControlName="approvedRejectedDate" id="approvedRejectedDateFilterInput"
            (ngModelChange)="approvedRejectedDateChanging($event)" [(ngModel)]="approvedRejectedDateFilter"
            (ngModelChange)="approvedRejectedDateChanged($event)" #approvedRejectedDateFilterInput
            [matDatepicker]="approvedRejectedDateDatePicker" (dateChange)="maybeDoAutoSearch()"
            placeholder="Approved Rejected Date">
          <mat-datepicker-toggle matSuffix [for]="approvedRejectedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #approvedRejectedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

      </div>

      <div class="search-section">

        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)">
          <mat-label i18n="@@type.TransferAsset.comments">Comments</mat-label>
          <input matInput formControlName="comments" id="commentsFilterInput" (ngModelChange)="commentsChanging($event)"
            [(ngModel)]="commentsFilter" (ngModelChange)="commentsChanged($event)" #commentsFilterInput maxlength="1000"
            placeholder="Comments">
        </mat-form-field>

        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.TransferAsset.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdByFilterInput"
            (ngModelChange)="createdByChanging($event)" [(ngModel)]="createdByFilter"
            (ngModelChange)="createdByChanged($event)" #createdByFilterInput maxlength="40" placeholder="Created By">
        </mat-form-field>

        <mat-form-field matTooltip="Date Created" [matTooltipDisabled]="disabledTooltip(this.dateCreated)">
          <mat-label i18n="@@type.TransferAsset.dateCreated">Date Created</mat-label>
          <input matInput formControlName="dateCreated" id="dateCreatedFilterInput"
            (ngModelChange)="dateCreatedChanging($event)" [(ngModel)]="dateCreatedFilter"
            (ngModelChange)="dateCreatedChanged($event)" #dateCreatedFilterInput [matDatepicker]="dateCreatedDatePicker"
            (dateChange)="maybeDoAutoSearch()" placeholder="Date Created">
          <mat-datepicker-toggle matSuffix [for]="dateCreatedDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #dateCreatedDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

      </div>

      <div class="search-section">

        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch" [ngModelOptions]="{standalone: true}">
          Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>


        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>

    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="transferAssetId">
            <mat-header-cell [crud-column-header]="columns.column('transferAssetId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.transferAssetId">
              Transfer Asset Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.transferAssetId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>
          
          <ng-container matColumnDef="assetId">
            <mat-header-cell [crud-column-header]="columns.column('assetId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.assetId">
              Asset Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.assetId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.businessUnit">
              Business Unit
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.businessUnit?.buId}} - {{element.businessUnit?.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="costCentre.ccId">
            <mat-header-cell [crud-column-header]="columns.column('costCentre.ccId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.costCentre">
              Cost Centre
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.costCentre?.ccId}} - {{element.costCentre?.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="approvalRejectionComment">
            <mat-header-cell [crud-column-header]="columns.column('approvalRejectionComment')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.approvalRejectionComment">
              Approval Rejection Comment
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.approvalRejectionComment}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="approved">
            <mat-header-cell [crud-column-header]="columns.column('approved')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.approved">
              Approved
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.approved}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="approvedRejectedBy">
            <mat-header-cell [crud-column-header]="columns.column('approvedRejectedBy')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.approvedRejectedBy">
              Approved Rejected By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.approvedRejectedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="approvedRejectedDate">
            <mat-header-cell [crud-column-header]="columns.column('approvedRejectedDate')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.approvedRejectedDate">
              Approved Rejected Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.approvedRejectedDate | uimDateFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="comments">
            <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.comments">
              Comments
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.comments}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.createdBy">
              Created By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dateCreated">
            <mat-header-cell [crud-column-header]="columns.column('dateCreated')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.dateCreated">
              Date Created
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.dateCreated | uimDateFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="pendingApproval">
            <mat-header-cell [crud-column-header]="columns.column('pendingApproval')" *matHeaderCellDef cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.TransferAsset.pendingApproval">
              Pending Approval
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.pendingApproval">check_box</mat-icon><mat-icon
                *ngIf="!element.pendingApproval">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>